import { makeStyles, Theme } from '@material-ui/core/styles';
import { Colors } from 'styles';

const useStyles = makeStyles((theme: Theme) => ({
  sticky_bar: {
    position: 'fixed',
    zIndex: 1190,
  },
  stickyBarTransition: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  appBarOpen: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  toolbar: {
    width: '100%',
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: Colors.TEXT_COLOR_DARK(),
  },
  elevateToolbar: {
    boxShadow: '0 5px 7px rgba(0,0,0,0.12), 0 3px 5px rgba(0,0,0,0.05)',
  },
}));

export default useStyles;
